import { render, staticRenderFns } from "./Recent.vue?vue&type=template&id=611a383c&scoped=true&"
var script = {}
import style0 from "./Recent.vue?vue&type=style&index=0&id=611a383c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a383c",
  null
  
)

export default component.exports